@if (currentProject) {
	<mat-form-field appearance="fill" class="form-field-mdc-legacy form-field-mdc-legacy-white text-box lessPadding">
		<input
			matInput
			#projectInput
			appSanitizeInput
			[value]="
				currentProject.client ? currentProject.client + ' - ' + currentProject.projectName : currentProject.projectName
			"
			[matAutocomplete]="projectAuto.matAutocomplete"
			(blur)="onLeaveText()"
		/>
		@if (projectInput.value.length > 0) {
			<button mat-icon-button matSuffix aria-label="Clear" (click)="onClear()">
				<mat-icon>close</mat-icon>
			</button>
		}
		<app-project-autocomplete
			#projectAuto
			(elementSelected)="onItemChange($event)"
			[inputElement]="projectInput"
			[onlyValidBUs]="true"
		>
		</app-project-autocomplete>
	</mat-form-field>
}
